export default __webpack_public_path__ + "static/media/DYHX.a1a14f15.png";